import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  TextField,
  Button,
  Box,
} from "@mui/material";
import { createJobTitle, updateJobTitle } from "../../services/jobTitle";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";

const JobTitleAdd = ({ open, onClose, editData, fetchJobTitles }) => {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [error, setError] = useState("");
  const snackRef = useRef();
  const [loading, setLoading] = useState(false);
  const dialogStyles = {
    dialog: {
      borderRadius: "8px",
      minWidth: "400px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      padding: "20px",
      border: "1px solid #e0e0e0",
      transition: "all 0.3s ease-in-out",
    },
    cancelButton: {
      backgroundColor: "red",
      color: "#fff",
      fontWeight: "bold",
      width: "100px",
    },
    submitButton: {
      backgroundColor: "primary.main",
      color: "#fff",
      fontWeight: "bold",
      width: "100px",
    },
  };

  useEffect(() => {
    if (editData) {
      setTitle(editData.name);
      setError("");
    } else {
      setTitle("");
    }
  }, [editData]);

  const handleSubmit = async () => {
    if (!title.trim()) {
      setError("Title is required.");
      return;
    }
    try {
      setLoading(true);
      if (editData) {
        const response = await updateJobTitle(editData._id, {
          name: title,
          price: price,
        });
        if (response.data.code === 200 || response.data.code === 201) {
          snackRef.current.isOpenSnack({
            snackType: "success",
            snackMessage: "Job Title updated successfully",
          });
        }
      } else {
        const response = await createJobTitle({ name: title, price: price });
        if (response.data.code === 200 || response.data.code === 201) {
          snackRef.current.isOpenSnack({
            snackType: "success",
            snackMessage: "Job Title added successfully",
          });
        }
      }
      setTitle("");
      onClose();
      fetchJobTitles();
    } catch (error) {
      console.error("Errors saving job title:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomSnackbar ref={snackRef} />
      <AppLoader isVisible={loading} />
      <Dialog open={open} onClose={onClose} sx={dialogStyles.dialog}>
        <DialogTitle borderBottom={1}>
          {editData ? "Edit Job Title" : "Add Job Title"}
        </DialogTitle>
        <Box width={400} padding={1}>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              setError("");
            }}
            required
            error={!!error}
            helperText={error}
          />
        </Box>
        <Box width={400} padding={1}>
          <TextField
            autoFocus
            margin="dense"
            label="Price"
            type="text"
            fullWidth
            value={price}
            onChange={(e) => {
              setPrice(e.target.value);
            }}
            required
            error={!!error}
            helperText={error}
          />
        </Box>
        <DialogActions
          sx={{ display: "flex", justifyContent: "right", padding: "5px" }}
        >
          <Button onClick={onClose} sx={dialogStyles.cancelButton}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} sx={dialogStyles.submitButton}>
            {editData ? "Save" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default JobTitleAdd;
